import React, { useCallback } from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Link,
  Typography,
  Tags,
} from '@gogame/components';
import { useLinkBasenameWithRoot } from '@gogame/screens';

import * as CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/ConceptFamilies/view-constants';
import {
  CONCEPT_FAMILY_ID,
  TAB_CONCEPTS,
} from 'scenes/Gallery/GalleryPage/constants';
import {
  conceptFamilyPreviewLink,
  galleryLink,
} from 'scenes/Gallery/GalleryPage/navigation';
import { valueParserCommaListFromStrings } from 'scenes/Gallery/GalleryPage/utils/valueParsers';

const ConceptFamilyDetailsGeneral = ({
  data = {},
  withNameField = true,
  termWidth = '25%',
}) => {
  const { [CONCEPT_FAMILY.ID]: conceptFamilyId } = data;

  const galleryBasename = useLinkBasenameWithRoot(galleryLink);

  const handleOpenInNewTab = useCallback(() => {
    const link = conceptFamilyPreviewLink.child(TAB_CONCEPTS).stringify(
      {
        [CONCEPT_FAMILY_ID]: `${conceptFamilyId}`,
      },
      {
        basename: galleryBasename,
      }
    );
    window.open(link);
  }, [conceptFamilyId, galleryBasename]);

  return (
    <DescriptionList
      stripEmpty={true}
      data={data}
      disableGutters={true}
      termWidth={termWidth}
    >
      {withNameField ? (
        <DescriptionItem
          label={'Name'}
          field={CONCEPT_FAMILY.NAME}
          type={({ value }) => (
            <Link
              data-cy={'Concept Family Page'}
              onClick={handleOpenInNewTab}
              target={'_blank'}
            >
              <Typography>{value}</Typography>
            </Link>
          )}
        />
      ) : null}
      <DescriptionItem
        label={'Applications'}
        field={CONCEPT_FAMILY.APPLICATIONS}
        valueParser={valueParserCommaListFromStrings}
      />
      <DescriptionItem
        label={'Internal Tags'}
        field={CONCEPT_FAMILY.INTERNAL_TAGS}
        type={({ value }) => <Tags data={value} lineClamp={4} />}
      />
      <DescriptionItem
        label={'Description'}
        field={CONCEPT_FAMILY.DESCRIPTION}
      />
    </DescriptionList>
  );
};

export default ConceptFamilyDetailsGeneral;
